//県別ページの出張展示会リスト部分を動的に生成するスクリプト
//Vue3にて実装

$(() => {
    //csvを読み込む
    const Showroom = {
        data() {
            return {
                showrooms:[],
                showrooms_pref:{}
            }
        },
        delimiters:['[[',']]'],
        mounted(){
            //CSVを読み込み
            var csv_url = 'https://xs791560.xsrv.jp/sellers/list_showtravel.csv'
            axios.get(csv_url).then(res=>{

                //初期設定
                var today = new Date()
                today.setHours(0)
                today.setMinutes(0)
                today.setSeconds(0)
                today.setMilliseconds(0)
                //console.log(today)
                var weekdays = ['日','月','火','水','木','金','土']

                //行で区切る
                let arr = res.data.split('\r\n')
                
                //カンマで区切る
                let data = []
                arr.forEach(element => {
                    data.push(element.split(','))
                })
                console.log(data)
                data.shift()

                //test用データ付加
                /*data.push(
                    ['301','35.894956','139.630767','','','2040/1/1','','test会場','','さいたまスーパーアリーナ　ＴＯＩＲＯ　SPACE　3・4・5','[1日目]10：00～16：00　[2日目]10：00～16：00','11','〒330-9111','埼玉県','さいたま市','埼玉県さいたま市中央区新都心8番地','さいたま新都心駅　徒歩3分','https://www.saitama-arena.co.jp/toiro/access/','','予約ボタン','','https://coubic.com/fit-chan/862890','travel_test_301','表示','2022/9/2'],
                    ['303','35.894956','139.630767','','','','','test会場','','さいたまスーパーアリーナ　ＴＯＩＲＯ　SPACE　3・4・5','[1日目]10：00～16：00　[2日目]10：00～16：00','11','〒330-9111','埼玉県','さいたま市','埼玉県さいたま市中央区新都心8番地','さいたま新都心駅　徒歩3分','https://www.saitama-arena.co.jp/toiro/access/','','予約ボタン','','https://coubic.com/fit-chan/862890','travel_test_303','表示','2022/9/2'],
                    ['303','35.894956','139.630767','','','2022/10/1','2022/10/30','test会場','','ほっかいどー','[1日目]10：00～16：00　[2日目]10：00～16：00','1','〒330-9111','ほっかいどー','ほっかいどー','埼ほっかいどー','ほっかいどー','https://www.saitama-arena.co.jp/toiro/access/','','予約ボタン','','https://coubic.com/fit-chan/862890','travel_test_303','表示','2022/9/2']
                )
                */
               
                //console.log(data)

                //レンダリング用データを生成
                data.forEach(sr => {
                    //日付変数セット
                    var is_2040 = false
                    var span_start
                    var span_end
                    if(sr[5] == '' || sr[6] == ''){
                        is_2040 = true
                        span_start = new Date(2040,0,1)
                        span_end = new Date(2040,0,1)
                    }else{
                        span_start = new Date(sr[5])
                        span_end = new Date(sr[6])
                    }                  

                    //終了しているか
                    var is_end = false
                    if(today > span_end){
                        is_end = true
                    }
                    //開始日と終了日が同じか
                    var is_sameday = false
                    if(sr[5] == sr[6]){
                        is_sameday = true
                    }

                    //予約日は過ぎているか
                    var is_reserve_start = false
                    var reserve_start_date = new Date(sr[24])
                    if(today >= reserve_start_date){
                        is_reserve_start = true
                    }

                    //開催日が2040年または空白ではないか
                    if(span_start.getFullYear()==2040){
                        is_2040 = true
                    }

                    //東京かどうか
                    var is_tokyo = false
                    if(sr[11]=='13'){
                        is_tokyo=true
                    }

                    if(sr[0]!='' && sr[23]=='表示'){
                        this.showrooms.push({
                            'is_end':is_end,
                            'is_sameday':is_sameday,
                            'is_2040':is_2040,
                            'is_reserve_start':is_reserve_start,
                            'span_start':span_start,
                            'span_end':span_end,
                            'span_start_year':span_start.getFullYear(),
                            'span_start_date':span_start.getMonth()+1 + '/' + span_start.getDate(),
                            'span_start_weekday':weekdays[span_start.getDay()],
                            'span_end_year':span_end.getFullYear(),
                            'span_end_date':span_end.getMonth()+1 + '/' + span_end.getDate(),
                            'span_end_weekday':weekdays[span_end.getDay()],
                            'name':sr[7],
                            'place':sr[9],
                            'time':sr[10],
                            'pref_id':Number(sr[11]),
                            'postcode':sr[12],
                            'address1':sr[13],
                            'address2':sr[14],
                            'address3':sr[15],
                            'route':sr[16],
                            'route_url':sr[17],
                            'reserve_url':sr[21],
                            'id':sr[22],
                            'reserve_text':sr[19],
                            'is_tokyo':is_tokyo,
                            'anchor':'#' + sr[11],
                            'reserve_alert_text':sr[18]
                        })
                    } 
                })

                //並び替え（開始日）
                this.showrooms = this.showrooms.sort(function(a, b) {
                    return (a.span_start < b.span_start) ? -1 : 1;  //オブジェクトの昇順ソート
                });

                //県別のオブジェクトを作成
                this.showrooms.forEach(sr => {
                    if(sr.pref_id in this.showrooms_pref){
                        this.showrooms_pref[sr.pref_id].push(sr)
                    }else{
                        this.showrooms_pref[sr.pref_id] = []
                        this.showrooms_pref[sr.pref_id].push(sr)
                    }
                })
                
                //デバッグ用書き出し
                console.log('ショールーム全部',this.showrooms)
                console.log('県別ショールーム',this.showrooms_pref)
            }).catch((error)=> {
                console.log('CSVの通信・処理で何らかのエラーが発生しました')
            })
        }
    }
        
    Vue.createApp(Showroom).mount('#vueapp')
})
